<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />
    <CommissionsReport />
  </Layout>
</template>

<script>
import Layout from '@/views/Layout'
import CommissionsReport from '@/components/Reports/Commissions/CommissionsReport'

export default {
  name: 'CommissionsReportsView',
  components: {
    Layout,
    CommissionsReport
  },
  computed: {
    breadcrumbs: () => [
      {
        text: 'Inicio',
        to: { name: 'HomeIndex' }
      },
      {
        text: 'Relatorios',
        to: { name: 'ReportsIndex' }
      },
      {
        text: 'Comissoes',
        to: { name: 'ReportCommissions' },
        active: true
      }
    ]
  }
}
</script>
